// extracted by mini-css-extract-plugin
module.exports = {"container":"_2iVB8DxqnxtsQRj1hK5CQw","cancelBtn":"PD5xHVrwl-zlfzS4TK5Zq","icon":"_2jYuhgTd6F_aV1DEPmqc9y","saveBtn":"_1Mr2PmIGbGVuEnwX_nIq8n"};